var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { useCallback } from "react";
import { useConfig } from "@/contexts/cdpConfig";
import { useBrandContext } from "@/shared/contexts";
import { fetchWithTimeout } from "@/utils";
export const useGeoSearch = () => {
    var _a;
    const token = (_a = useConfig()) === null || _a === void 0 ? void 0 : _a.geoApiToken;
    const { urls, searchCountries } = useBrandContext();
    const queryPlaceTypes = `&place_types=HONU&place_types=STRT`;
    const filteredCountries = searchCountries
        .map((country) => `&countries=${country}`)
        .join("");
    const searchLocations = useCallback((term) => __awaiter(void 0, void 0, void 0, function* () {
        if (!term)
            return;
        try {
            const response = yield fetchWithTimeout(`${urls.autocompleteApiUrl}?text=${encodeURIComponent(term)}${queryPlaceTypes}${filteredCountries}`, {
                method: "GET",
                // @ts-ignore
                headers: {
                    "Content-Type": "application/json",
                    "x-api-key": token,
                },
            });
            if (response.error) {
                throw new Error(`API Error: ${response.statusText}`);
            }
            const { items } = yield response.json();
            return items === null || items === void 0 ? void 0 : items.map((item) => {
                const languageKey = Object.keys(item.names)[0];
                return {
                    id: item.id,
                    // @ts-ignore
                    label: item.names[languageKey][0].display_name,
                    coordinates: item.coordinates,
                };
            });
        }
        catch (err) {
            console.error(err);
        }
    }), [filteredCountries, queryPlaceTypes, token, urls.autocompleteApiUrl]);
    return {
        searchLocations,
    };
};
